import type { TrackerRouteSummaryItem } from '@shared/tracker-types';

export function summarizeOperatorWork(stores: TrackerRouteSummaryItem[]) {
  const summary = { total: 0, reported: 0, signedStores: 0, awaitingSignature: 0,
    approved: 0, awaitingReview: 0, rejected: 0, notSubmitted: 0,
    signaturesAvailable: stores.length > 0 && stores.every(store => store.signedAt !== undefined),
    countsAvailable: stores.length > 0 && stores.every(store => !!store.campaignStatusCountsByType),
    types: { POSTING: { total: 0, reported: 0 }, REMOVAL: { total: 0, reported: 0 }, REPOST: { total: 0, reported: 0 } },
    latestStore: null as TrackerRouteSummaryItem | null };
  for (const store of stores) {
    summary.total += store.totalTasks;
    summary.reported += store.submittedTaskCount;
    const workReported = store.totalTasks > 0 && store.submittedTaskCount === store.totalTasks;
    if (workReported && store.signedAt) summary.signedStores++;
    if (workReported && store.signedAt === null) summary.awaitingSignature++;
    if (store.lastActivityAt && Number.isFinite(Date.parse(store.lastActivityAt)) &&
      (!summary.latestStore?.lastActivityAt || Date.parse(store.lastActivityAt) > Date.parse(summary.latestStore.lastActivityAt))) summary.latestStore = store;
    if (!store.campaignStatusCountsByType) continue;
    for (const type of ['POSTING', 'REMOVAL', 'REPOST'] as const) {
      const counts = store.campaignStatusCountsByType[type];
      summary.types[type].total += counts.totalTasks;
      summary.types[type].reported += counts.submitted;
      summary.approved += counts.approved;
      summary.awaitingReview += counts.awaitingReview;
      summary.rejected += counts.rejected;
      summary.notSubmitted += counts.notSubmitted;
    }
  }
  return summary;
}

export function describeStoreWork(store: TrackerRouteSummaryItem): string {
  if (store.totalTasks > 0 && store.submittedTaskCount === store.totalTasks) {
    if (store.signedAt) return 'All work recorded · signature received';
    return store.signedAt === null ? 'All work recorded · signature not received' : 'All work recorded · signature status unavailable';
  }
  if (store.submittedTaskCount > 0) return 'Some work recorded · tasks still outstanding';
  return 'No work recorded yet';
}
